var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("label", [_vm._v("Roles")]),
      _c(
        "md-select",
        {
          attrs: { multiple: false, disabled: _vm.isBaseUser() },
          on: { selected: _vm.onSelected },
          model: {
            value: _vm.selected[0],
            callback: function($$v) {
              _vm.$set(_vm.selected, 0, $$v)
            },
            expression: "selected[0]"
          }
        },
        [
          _vm.isAdmin()
            ? _c("md-option", { attrs: { value: "Admin" } }, [_vm._v("Admin")])
            : _vm._e(),
          _vm._l(_vm.roles, function(role) {
            return _c(
              "md-option",
              { key: role.key, attrs: { value: role.key } },
              [_vm._v(_vm._s(role.value))]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7db82852", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db82852","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/user/UserRolesSelector.vue
// module id = 713
// module chunks = 0